import fish0 from '../../../assets/images/fishes/bottle.png';
import fish1 from '../../../assets/images/fishes/piranha.png';
import fish2 from '../../../assets/images/fishes/shark.png';
import fish3 from '../../../assets/images/fishes/king-salmon.png';
import fish4 from '../../../assets/images/fishes/oscar.png';
import fish5 from '../../../assets/images/fishes/bicolourparrotfish.png';
import fish6 from '../../../assets/images/fishes/synchiropussplendidus.png';
import fish7 from '../../../assets/images/fishes/roosterfish.png';
import fish8 from '../../../assets/images/fishes/gulf-grouper.png';
import fish9 from '../../../assets/images/fishes/tuna.png';

/// 213123
// import fish_10 from '../../../assets/images/fishes/bottle.png';
/// 213123

import fish11 from '../../../assets/images/fishes/lion-fish.png';
import fish12 from '../../../assets/images/fishes/fugu.png';
import fish13 from '../../../assets/images/fishes/sockeyesalmon.png';
import fish14 from '../../../assets/images/fishes/triggerfish.png';

/// UNUSED
// import fish_15 from '../../../assets/images/fishes/bottle.png';
/// UNUSED

import fish16 from '../../../assets/images/fishes/perch.png';
import fish17 from '../../../assets/images/fishes/wahoo.png';
import fish18 from '../../../assets/images/fishes/catfish.png';
import fish19 from '../../../assets/images/fishes/plaice.png';
import fish20 from '../../../assets/images/fishes/dolphinfish.png';
import fish21 from '../../../assets/images/fishes/marlin.png';
// import fish_shark from '../../../assets/images/fishes/bottle.png';

export const FishByType = [
  fish0,
  fish1,
  fish2,
  fish3,
  fish4,
  fish5,
  fish6,
  fish7,
  fish8,
  fish9,
  // fish_10,
  fish11,
  fish12,
  fish13,
  fish14,
  // fish_15,
  fish16,
  fish17,
  fish18,
  fish19,
  fish20,
  fish21,
  // fish_shark,
];
